"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function useResettableNetworkStatus(sourceStatus) {
    /** An internal reference to the modified status */
    var _a = react_1.useState(sourceStatus), localRequestStatus = _a[0], updateLocalRequestStatus = _a[1];
    /**
     * Keep track of the original state
     */
    react_1.useEffect(function () {
        updateLocalRequestStatus(sourceStatus);
    }, [sourceStatus]);
    /**
     * Reset whenever we detect a "final" state change
     */
    react_1.useEffect(function () {
        if (['success', 'failure'].includes(localRequestStatus)) {
            updateLocalRequestStatus('initial');
        }
    }, [localRequestStatus]);
    return localRequestStatus;
}
exports.default = useResettableNetworkStatus;
//# sourceMappingURL=useResettableNetworkStatus.js.map